import {
    URLAPI,
    CRITICAL_LEVELS_PATH,
    CRITICAL_LEVEL_CREATE_PATH,
    CRITICAL_LEVEL_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_critical_levels: {
        data: [],
        status: 0,
        message: {},
    },
    _create_critical_level: {
        data: {},
        status: 0,
        message: {},
    },
    _update_critical_level: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_CRITICAL_LEVELS = "GET_ALL_CRITICAL_LEVELS";
export const CREATE_CRITICAL_LEVEL = "CREATE_CRITICAL_LEVEL";
export const UPDATE_CRITICAL_LEVEL = "UPDATE_CRITICAL_LEVEL";

export const critical_levels_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_CRITICAL_LEVELS:
            return {
                ...state,
                _get_all_critical_levels: action.payload,
            };
        case CREATE_CRITICAL_LEVEL:
            return {
                ...state,
                _create_critical_level: action.payload,
            };
        case UPDATE_CRITICAL_LEVEL:
            return {
                ...state,
                _update_critical_level: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllCriticalLevels = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${CRITICAL_LEVELS_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_CRITICAL_LEVELS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_CRITICAL_LEVELS,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_CRITICAL_LEVELS,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createCriticalLevel = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${CRITICAL_LEVEL_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_CRITICAL_LEVEL,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_CRITICAL_LEVEL,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_CRITICAL_LEVEL,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateCriticalLevel = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${CRITICAL_LEVEL_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_CRITICAL_LEVEL,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_CRITICAL_LEVEL,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_CRITICAL_LEVEL,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_critical_level = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
